import React, { useEffect, useRef, useState } from 'react';
import './App.scss';
import Dashboard from './components/dashboard/Dashboard';
import InfoPopup from './components/info/InfoPopup';
import LegendSimple from './components/legend/LegendSimple';
import Map from './components/map/Map';
import Navigation from './components/navigation/Navigation';
import { ThemeProvider } from '@mui/material/styles';
import { customTheme } from './theme';
import LegendMultipleSteps from './components/legend/LegendMultipleSteps';
import { useTheme } from '@emotion/react';
import { useMediaQuery } from '@mui/material';




export default function AppContent() {

    const [dashboardData, setDashboardData] = useState([])
    const [layerSelection, setLayerSelection] = useState({
        layer1: "ARNSBERG",
        layer2: "WALDVITALITAET",
        period: "2016_2020",
        opacity: 1
    })

    const [dashboardOpen, setDashboardOpen] = useState(false)
    const [selectedPolygonId, setSelectedPolygonId] = useState("");

    const [infoPopup, setInfoPopup] = useState(
        {
            open: false,
            id: "",
            title: ""
        }
    );


    return (
        <>
            <InfoPopup infoPopup={infoPopup} setInfoPopup={setInfoPopup} />
            <Dashboard
                layerSelection={layerSelection}
                dashboardData={dashboardData}
                open={dashboardOpen}
                setOpen={setDashboardOpen}
                selectedPolygonId={selectedPolygonId}
                setInfoPopup={setInfoPopup}
            />

            <Navigation
                layerSelection={layerSelection}
                setLayerSelection={setLayerSelection}
                setSelectedPolygonId={setSelectedPolygonId}
                setDashboardData={setDashboardData}
                setDashboardOpen={setDashboardOpen}
                setInfoPopup={setInfoPopup}
            />
            <LegendSimple layerSelection={layerSelection}></LegendSimple>

            {
            // mobile &&
                (layerSelection.layer2 === "WALDVITALITAET" || layerSelection.layer2 === "WASSERDEFIZIT") ? <LegendMultipleSteps layerSelection={layerSelection}></LegendMultipleSteps> :
                <LegendSimple layerSelection={layerSelection}></LegendSimple>}
            <Map
                setLayerSelection={setLayerSelection}
                layerSelection={layerSelection}
                setDashboardData={setDashboardData}
                selectedPolygonId={selectedPolygonId}
                setSelectedPolygonId={setSelectedPolygonId}
            ></Map>
        </>
    )
}